var _path, _polygon, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M651.72,163.5c-12.4-46.28-49.24-84.79-94.1-97.12s-96.05,2.48-127.76,37.83c-15.49,17.26-26.65,39-45.15,52.71-22.52,16.69-52.09,18.68-79.66,16.93s-55.43-6.63-82.61-1.37c-43.56,8.43-81,44.76-92,89.21s5.18,94.62,39.61,123.2l38.07,31.5c34.91,25.35,167.16,35.93,249.51,29.66,58.29-4.44,98.11-26.81,133.21-61.73,27.16-27,43.25-63.87,54-101.18C656.1,244.29,662.15,202.44,651.72,163.5Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stopwatch--inject-30"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 482.04,
    y: 108.34,
    width: 12.52,
    height: 19.54,
    transform: "matrix(0.76, -0.65, 0.65, 0.76, 41.07, 346.95)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.58,106.67,476,123.49l-13.73-16c5.4-7.58,11.84-13.3,19.55-16.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.3,120.67c-.11.1-3.42-3.54-7.4-8.11s-7.12-8.35-7-8.45,3.42,3.54,7.4,8.11S479.41,120.58,479.3,120.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483,117.47A23.15,23.15,0,0,1,480.8,115c-1.32-1.55-3.11-3.7-5.08-6.1l-5-6.16-1.5-1.87c-.36-.46-.55-.67-.55-.7.2-.18,3.53,3.61,7.47,8.4,2,2.4,3.72,4.59,5,6.2A18.59,18.59,0,0,1,483,117.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488,113.2a22.56,22.56,0,0,1-2.23-2.47c-1.33-1.57-3.13-3.76-5.11-6.19l-5-6.26-1.5-1.91a5.13,5.13,0,0,1-.52-.73,14.13,14.13,0,0,1,2.3,2.41c1.35,1.55,3.17,3.73,5.14,6.16s3.74,4.66,5,6.29A19.7,19.7,0,0,1,488,113.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.51,109.2c-.11.09-3.4-3.58-7.35-8.2s-7.05-8.45-6.94-8.55,3.39,3.58,7.34,8.21S492.62,109.11,492.51,109.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 637.26,
    y: 110.4,
    width: 12.52,
    height: 19.54,
    transform: "translate(285.81 -428.11) rotate(46.3)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.33,126.84l-17.82-18.65,15.23-14.55c7.84,5,13.9,11.13,17.81,18.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.49,111.32c-.1-.11,3.35-3.61,7.71-7.82s8-7.54,8.07-7.44-3.35,3.6-7.71,7.82S640.59,111.42,640.49,111.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.89,114.87a20.93,20.93,0,0,1,2.32-2.34c1.47-1.4,3.53-3.31,5.82-5.41l5.89-5.33,1.79-1.6c.43-.38.64-.57.67-.58.19.19-3.42,3.72-8,7.9-2.29,2.09-4.39,4-5.93,5.29A20.91,20.91,0,0,1,643.89,114.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.41,119.6a21,21,0,0,1,2.35-2.36c1.49-1.41,3.58-3.33,5.91-5.43l6-5.34,1.83-1.6a8.5,8.5,0,0,1,.7-.56,14.09,14.09,0,0,1-2.28,2.43c-1.48,1.43-3.57,3.36-5.89,5.46s-4.46,4-6,5.32A21.74,21.74,0,0,1,648.41,119.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.64,123.91c-.1-.11,3.4-3.58,7.81-7.77s8.07-7.49,8.17-7.38-3.4,3.58-7.81,7.76S652.74,124,652.64,123.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560.26,
    y: 74.72,
    width: 14.82,
    height: 23.13,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583,81.64H552.5V56.71c10.69-2.64,20.89-2.8,30.53,0Z",
    style: {
      fill: "#1990FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.39,56.81a6.38,6.38,0,0,1-1.13.56,27.37,27.37,0,0,1-3.21,1.18,38.36,38.36,0,0,1-5,1.18,42.23,42.23,0,0,1-6.21.52,41.32,41.32,0,0,1-6.21-.46,37.5,37.5,0,0,1-5-1.13,29.31,29.31,0,0,1-3.22-1.15,5.28,5.28,0,0,1-1.13-.55c0-.09,1.68.6,4.45,1.34a43,43,0,0,0,4.94,1,46.53,46.53,0,0,0,6.14.42,46.24,46.24,0,0,0,6.14-.48,44.16,44.16,0,0,0,4.92-1C581.71,57.43,583.35,56.72,583.39,56.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.58,81.57c-.14,0-.26-4.79-.26-10.69s.12-10.69.26-10.69.26,4.78.26,10.69S562.73,81.57,562.58,81.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.39,81.71c-.14,0-.26-4.81-.26-10.74s.12-10.73.26-10.73.26,4.8.26,10.73S568.54,81.71,568.39,81.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.2,81.62c-.14,0-.26-4.81-.26-10.74s.12-10.74.26-10.74.26,4.81.26,10.74S574.35,81.62,574.2,81.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579,81.62c-.15,0-.26-5.2-.26-11.61s.11-11.61.26-11.61.26,5.2.26,11.61S579.18,81.62,579,81.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.09,81.47c-.14,0-.26-5.2-.26-11.61s.12-11.61.26-11.61.26,5.2.26,11.61S557.24,81.47,557.09,81.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 565.88,
    cy: 198.53,
    r: 107.83,
    transform: "translate(25.36 458.28) rotate(-45)",
    style: {
      fill: "#1990FF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 565.88,
    cy: 197.67,
    r: 90.56,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.44,197.67s0-.49-.07-1.46,0-2.42-.19-4.31a90.06,90.06,0,0,0-2.58-16.34,88.71,88.71,0,0,0-3.71-11.36,87.7,87.7,0,0,0-6.3-12.74,91.65,91.65,0,0,0-23-25.69,90.2,90.2,0,0,0-38.05-16.88,92.06,92.06,0,0,0-35.41.41,97.55,97.55,0,0,0-12.08,3.45,90.57,90.57,0,0,0-42,31.49,88.45,88.45,0,0,0-7.36,11.86c-1.11,2.07-2.06,4.22-3,6.38s-1.78,4.4-2.49,6.68a86.38,86.38,0,0,0-3.44,14,97.42,97.42,0,0,0-1.19,14.53,99,99,0,0,0,1.18,14.54,88.92,88.92,0,0,0,3.44,14c.72,2.27,1.62,4.47,2.49,6.67s1.92,4.32,3,6.39a87.5,87.5,0,0,0,7.37,11.86,90.54,90.54,0,0,0,42,31.5,97.55,97.55,0,0,0,12.08,3.45,90.86,90.86,0,0,0,12.11,1.69,89.78,89.78,0,0,0,23.3-1.28,90.2,90.2,0,0,0,38.05-16.88,91.49,91.49,0,0,0,23-25.69,88.2,88.2,0,0,0,6.3-12.74,89.87,89.87,0,0,0,6.29-27.7c.17-1.89.14-3.34.19-4.31s.07-1.47.07-1.47,0,.5,0,1.47,0,2.42-.14,4.31a88.72,88.72,0,0,1-6.17,27.79,87.47,87.47,0,0,1-6.28,12.8,91.66,91.66,0,0,1-23,25.83,90.58,90.58,0,0,1-38.2,17,90.14,90.14,0,0,1-23.41,1.32,91.5,91.5,0,0,1-12.17-1.69,96.42,96.42,0,0,1-12.15-3.46,91,91,0,0,1-42.25-31.65,88.34,88.34,0,0,1-7.4-11.92c-1.12-2.08-2.08-4.26-3.06-6.43s-1.78-4.42-2.5-6.71a88.83,88.83,0,0,1-3.46-14.06,90.4,90.4,0,0,1,0-29.24,89,89,0,0,1,3.46-14c.73-2.29,1.63-4.5,2.51-6.71s1.93-4.34,3.05-6.42a89.42,89.42,0,0,1,7.41-11.92,90.92,90.92,0,0,1,42.24-31.64,96.76,96.76,0,0,1,12.14-3.46,91.88,91.88,0,0,1,12.18-1.69,90.06,90.06,0,0,1,23.4,1.32,90.26,90.26,0,0,1,38.2,17,91.74,91.74,0,0,1,23,25.84,91.26,91.26,0,0,1,10,24.2,89.69,89.69,0,0,1,2.49,16.39c.15,1.89.1,3.34.14,4.31S656.44,197.67,656.44,197.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.15,194.39c-2.87.12-5.21,0-5.22-.25s2.3-.59,5.17-.75,5.21-.06,5.23.24S646,194.27,643.15,194.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.22,215.24c-2.8-.66-5-1.39-5-1.64s2.38.05,5.19.66,5,1.35,5,1.64S644,215.89,641.22,215.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.75,234.79c-2.53-1.38-4.47-2.69-4.35-2.91s2.28.69,4.82,2,4.49,2.66,4.35,2.92S636.27,236.18,633.75,234.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.3,251.63c-2.06-2-3.59-3.78-3.41-4s2,1.27,4.1,3.25,3.61,3.75,3.41,4S623.35,253.64,621.3,251.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.8,264.53c-1.44-2.49-2.44-4.61-2.22-4.74s1.6,1.77,3.08,4.23,2.48,4.58,2.23,4.74S606.25,267,604.8,264.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.45,272.52c-.72-2.79-1.11-5.1-.86-5.16s1.06,2.13,1.83,4.9,1.15,5.08.86,5.16S586.17,275.3,585.45,272.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.66,275c0-2.88.29-5.21.54-5.21s.46,2.34.46,5.21-.25,5.21-.54,5.21S564.61,277.89,564.66,275Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544,271.87c.82-2.76,1.68-4.93,1.93-4.86s-.19,2.37-1,5.14-1.64,5-1.93,4.86S543.13,274.63,544,271.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.87,263.26c1.53-2.43,2.94-4.3,3.16-4.17s-.82,2.24-2.31,4.7-2.91,4.32-3.16,4.17S523.34,265.7,524.87,263.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.78,249.86c2.13-1.94,4-3.36,4.16-3.17s-1.38,1.93-3.48,3.9-3.95,3.39-4.16,3.18S506.66,251.8,508.78,249.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.86,232.64c2.57-1.29,4.75-2.16,4.86-1.94s-1.85,1.49-4.4,2.83-4.72,2.21-4.86,1.94S494.3,233.94,496.86,232.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490,212.86c2.83-.56,5.16-.81,5.21-.56s-2.19.94-5,1.54-5.15.85-5.21.56S487.2,213.42,490,212.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.73,192c2.87.21,5.18.59,5.17.84s-2.36.32-5.23.15-5.19-.54-5.17-.84S485.86,191.74,488.73,192Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.08,171.47c2.71,1,4.83,2,4.75,2.21s-2.36-.33-5.08-1.27-4.84-1.92-4.75-2.2S490.38,170.49,493.08,171.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.79,152.92c2.34,1.67,4.12,3.19,4,3.4s-2.18-.95-4.55-2.58-4.15-3.15-4-3.4S500.44,151.25,502.79,152.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.1,137.64c1.81,2.23,3.12,4.17,2.93,4.34s-1.86-1.5-3.7-3.71-3.16-4.14-2.93-4.33S515.29,135.41,517.1,137.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535,126.74c1.14,2.64,1.89,4.86,1.65,5s-1.38-1.94-2.56-4.56-1.93-4.84-1.66-5S533.83,124.11,535,126.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.14,121.07c.39,2.85.51,5.19.25,5.23s-.81-2.24-1.24-5.08-.55-5.19-.26-5.23S554.75,118.22,555.14,121.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.08,121c-.38,2.85-.89,5.14-1.14,5.11s-.19-2.38.15-5.23.85-5.15,1.14-5.11S576.46,118.14,576.08,121Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.27,126.53c-1.13,2.65-2.24,4.71-2.48,4.61s.47-2.33,1.56-5,2.21-4.72,2.48-4.6S597.41,123.89,596.27,126.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.23,137.3c-1.8,2.25-3.42,3.94-3.62,3.78s1.07-2.13,2.84-4.4,3.38-4,3.62-3.77S616,135.06,614.23,137.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.66,152.48c-2.34,1.68-4.35,2.88-4.5,2.67s1.6-1.76,3.91-3.48,4.32-2.91,4.5-2.67S631,150.8,628.66,152.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.49,171c-2.7,1-5,1.59-5.06,1.36s2-1.27,4.71-2.3,4.94-1.64,5.05-1.36S641.19,170,638.49,171Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643,191.42c-2.87.23-5.21.21-5.23,0s2.28-.67,5.14-1,5.21-.25,5.23.05S645.84,191.19,643,191.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.71,99.7l-.31.14-.92.37c-.8.34-2,.75-3.53,1.42a105,105,0,0,0-12.53,6.25c-2.56,1.48-5.27,3.25-8.12,5.24s-5.76,4.31-8.67,6.92a102.19,102.19,0,0,0-28.39,41.53c-1.37,3.66-2.4,7.24-3.29,10.59s-1.49,6.55-1.94,9.47a105.92,105.92,0,0,0-1.27,13.94c-.08,1.66,0,2.94,0,3.81,0,.42,0,.74,0,1a2.14,2.14,0,0,1,0,.34,1.39,1.39,0,0,1,0-.33c0-.25,0-.58,0-1,0-.87-.11-2.15-.06-3.81a98.32,98.32,0,0,1,1.11-14c.42-2.94,1.07-6.13,1.88-9.52a108.59,108.59,0,0,1,3.26-10.65,101.18,101.18,0,0,1,28.53-41.73c2.93-2.61,5.91-4.86,8.73-6.91s5.6-3.75,8.19-5.21a99.25,99.25,0,0,1,12.63-6.12c1.53-.64,2.76-1,3.58-1.33l.94-.32A1.37,1.37,0,0,1,530.71,99.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.81,93.86a21.26,21.26,0,0,1-3.12.41c-1.94.2-4.6.49-7.54.87s-5.59.78-7.51,1.08a20.91,20.91,0,0,1-3.12.4,17.17,17.17,0,0,1,3.06-.76c1.91-.39,4.56-.85,7.5-1.23s5.63-.62,7.58-.73A16.82,16.82,0,0,1,560.81,93.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M493.5,252.11s46.93,74.06,119.73,36.13c76-39.6,34-130.37,34-130.37s35.76,72.34-38.32,119.5c-18.45,11.75-38.54,11.76-53.86,10.22C515.9,283.67,493.5,252.11,493.5,252.11Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M591.12,149.54a311.16,311.16,0,0,1-1.2,39.81c-.46,4.79-1,9.63-2.85,14.08s-5,8.53-9.44,10.41-10.12,1.1-13.21-2.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "563.91 190.53 596.82 135.11 576.96 197.68 566.81 200.71 563.91 190.53",
    style: {
      fill: "#1990FF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "596.82 135.11 572.41 191.74 576.96 197.68 596.82 135.11"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 566.81,
    cy: 200.71,
    r: 10.59,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.4,200.71a23,23,0,0,0-.43-2.56,10.58,10.58,0,0,0-3.86-5.71,10.39,10.39,0,0,0-9.83-1.45,9.6,9.6,0,0,0-2.61,1.41,9.73,9.73,0,0,0-2.19,2.2,10.33,10.33,0,0,0,0,12.22,10.53,10.53,0,0,0,4.8,3.62A10.46,10.46,0,0,0,577,203.27a22.18,22.18,0,0,0,.43-2.56,8.31,8.31,0,0,1-.23,2.61,10.56,10.56,0,0,1-3.84,6,10.67,10.67,0,0,1-4.53,2.05,10.83,10.83,0,0,1-5.68-.44,9.88,9.88,0,0,1-2.75-1.47,10.24,10.24,0,0,1-2.3-2.3,10.75,10.75,0,0,1,0-12.82,10.45,10.45,0,0,1,2.3-2.3,10.27,10.27,0,0,1,2.75-1.46,10.73,10.73,0,0,1,5.68-.44,10.68,10.68,0,0,1,8.37,8A8.32,8.32,0,0,1,577.4,200.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 566.81,
    cy: 200.71,
    r: 7.88,
    transform: "translate(257.79 716.53) rotate(-78.57)",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Calendar--inject-30"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "483.32 454.89 535.42 454.89 511.13 245.55 483.32 454.89",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.96 245.55 193.04 457.36 482.49 461.13 511.13 245.55 226.96 245.55",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "498.24 342.58 211.42 342.58 217.66 303.58 503.42 303.58 498.24 342.58",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.26,342.61H211.39v0l6.25-39H503.45v0Zm-286.81-.05H498.22l5.17-39H217.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.96 245.55 217.66 303.58 503.42 303.58 511.13 245.55 226.96 245.55",
    style: {
      fill: "#1990FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227,245.55l284.17-.24h.27l0,.27c-8.37,63.11-17.87,134.68-27.91,210.27l0,.23h-3.48L193.28,456H193l0-.25L227,245.55c-.28,1.74-13.2,82.95-33.47,210.3l-.21-.25,286.66,0h3.25l-.25.22c10.05-75.59,19.57-147.15,28-210.26l.23.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.42,303.58c0,.14-64,.26-142.87.26s-142.89-.12-142.89-.26,64-.26,142.89-.26S503.42,303.43,503.42,303.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.24,342.58c0,.15-64.34.26-143.68.26s-143.69-.11-143.69-.26,64.32-.26,143.69-.26S498.24,342.44,498.24,342.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.4,378.47c0,.15-64.33.26-143.67.26S205,378.62,205,378.47s64.32-.26,143.69-.26S492.4,378.33,492.4,378.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.57,414.36c0,.14-64.34.26-143.68.26s-143.69-.12-143.69-.26,64.32-.26,143.69-.26S486.57,414.22,486.57,414.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.67,456.14c-.14,0,5.11-34.2,11.74-76.32s12.1-76.27,12.24-76.24-5.11,34.18-11.73,76.32S233.82,456.16,233.67,456.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.9,456.14c-.15,0,5.11-34.2,11.73-76.32s12.1-76.27,12.25-76.24-5.11,34.18-11.74,76.32S278,456.16,277.9,456.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319,454.61c-.14,0,5.06-33.85,11.61-75.55s12-75.51,12.13-75.48-5.06,33.84-11.61,75.56S319.13,454.63,319,454.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.65,455.82c-.14,0,5.1-34.13,11.71-76.16s12.08-76.11,12.22-76.08-5.1,34.11-11.71,76.16S359.79,455.84,359.65,455.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.5,455.82c-.14,0,5.1-34.13,11.71-76.16s12.08-76.11,12.22-76.08-5.09,34.11-11.7,76.16S400.65,455.84,400.5,455.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.32,456c-.14,0,5.11-34.17,11.73-76.27s12.09-76.22,12.24-76.19-5.11,34.16-11.73,76.27S441.46,456.06,441.32,456Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M415.62,306.3c4.92-2.18,8-7.3,9.27-12.53s1.07-10.69,1.26-16.08.83-10.94,3.58-15.57c1.63-2.73,3.92-5,5.73-7.63s3.15-5.83,2.48-9l-30.78.16Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M288,345.47a1.63,1.63,0,0,1-.3.36l-.92,1c-.81.83-2,2-3.5,3.46-3,2.88-7.17,6.8-11.92,11s-9.15,7.86-12.38,10.46c-1.62,1.3-2.94,2.34-3.86,3l-1.07.8a1.48,1.48,0,0,1-.4.25s.11-.13.33-.33l1-.88,3.75-3.17c3.18-2.67,7.54-6.38,12.28-10.56s9-8.06,12-10.87l3.61-3.33,1-.89A1.92,1.92,0,0,1,288,345.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.69,376.2A11.8,11.8,0,0,1,284.5,375l-3.13-3.34c-2.7-2.87-6.32-6.73-10.31-11l-10.42-10.9-3.16-3.31a12.05,12.05,0,0,1-1.11-1.26,9.33,9.33,0,0,1,1.26,1.12c.78.74,1.9,1.83,3.27,3.19,2.74,2.72,6.48,6.53,10.53,10.81s7.65,8.22,10.21,11.11c1.28,1.44,2.31,2.62,3,3.44A9.25,9.25,0,0,1,285.69,376.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.37,354.66s.1-.26.31-.77a12.68,12.68,0,0,1,1.2-2.11,15.21,15.21,0,0,1,7.42-5.53,15.73,15.73,0,0,1,6.69-.88,17.49,17.49,0,0,1,7.6,2.59,20.3,20.3,0,0,1,6.55,6.5,17,17,0,0,1,2.73,9.93,11.36,11.36,0,0,1-1.71,5.34,13.62,13.62,0,0,1-4.12,4.16A19.87,19.87,0,0,1,311.16,377a20.52,20.52,0,0,1-6.4-1.39,15.24,15.24,0,0,1-5.6-3.8,13.07,13.07,0,0,1-1.94-2.91,12.69,12.69,0,0,1-1-3.38,16.16,16.16,0,0,1,.61-7.13,19.63,19.63,0,0,1,9.26-11.25,17.09,17.09,0,0,1,15.05-.69,15.78,15.78,0,0,1,6.31,4.83,15.14,15.14,0,0,1,3,7.49,14.65,14.65,0,0,1-1.29,8.08,13.56,13.56,0,0,1-2.38,3.44,16.26,16.26,0,0,1-3.3,2.59,20.25,20.25,0,0,1-16.09,1.5,18.37,18.37,0,0,1-7-4,12.87,12.87,0,0,1-3.89-6.91,11.39,11.39,0,0,1,1.05-7.7,9.56,9.56,0,0,1,2.54-3,11.92,11.92,0,0,1,3.4-1.79,21.35,21.35,0,0,1,7.44-1,28.34,28.34,0,0,1,7.26,1,15.4,15.4,0,0,1,6.31,3.38,11.33,11.33,0,0,1,3.38,6.06,13.18,13.18,0,0,1-.39,6.75,14,14,0,0,1-3.49,5.55,17.19,17.19,0,0,1-11.21,4.88,15,15,0,0,1-5.8-.84,11.84,11.84,0,0,1-4.68-3.09,12.67,12.67,0,0,1-2.71-4.61,13.45,13.45,0,0,1-.73-5,13.28,13.28,0,0,1,3.54-8.44,15.79,15.79,0,0,1,6.73-4.35,15.46,15.46,0,0,1,6.72-.64,18.09,18.09,0,0,1,8.61,3.47,16.72,16.72,0,0,1,1.85,1.58c.39.39.58.6.58.6s-.22-.19-.61-.56a19.58,19.58,0,0,0-1.88-1.54,18.26,18.26,0,0,0-8.57-3.35,15.38,15.38,0,0,0-13.21,5,12.93,12.93,0,0,0-3.43,8.25,13.21,13.21,0,0,0,.73,4.9,12.39,12.39,0,0,0,2.65,4.47,11.57,11.57,0,0,0,4.54,3,14.81,14.81,0,0,0,5.65.8,16.77,16.77,0,0,0,10.93-4.79,13.55,13.55,0,0,0,3.37-5.37,12.74,12.74,0,0,0,.36-6.52,10.92,10.92,0,0,0-3.25-5.82,15.1,15.1,0,0,0-6.12-3.26,28.22,28.22,0,0,0-7.14-1,21.09,21.09,0,0,0-7.26,1A9.86,9.86,0,0,0,298,356a10.91,10.91,0,0,0-1,7.36,12.32,12.32,0,0,0,3.75,6.63,17.74,17.74,0,0,0,6.8,3.92,19.69,19.69,0,0,0,15.66-1.46,15.18,15.18,0,0,0,3.19-2.5,13.1,13.1,0,0,0,2.29-3.3,14.11,14.11,0,0,0,1.25-7.8,14.65,14.65,0,0,0-2.87-7.24,15.27,15.27,0,0,0-6.1-4.67,16.57,16.57,0,0,0-14.61.66,19.13,19.13,0,0,0-9,10.95,15.84,15.84,0,0,0-.61,6.92,12.26,12.26,0,0,0,1,3.26,12.87,12.87,0,0,0,1.86,2.8,14.76,14.76,0,0,0,5.42,3.68,20.17,20.17,0,0,0,6.26,1.38,19.5,19.5,0,0,0,11.64-3,12,12,0,0,0,5.69-9.2,16.68,16.68,0,0,0-2.65-9.72,20,20,0,0,0-6.42-6.43,17.3,17.3,0,0,0-7.47-2.59,15.36,15.36,0,0,0-6.6.82,15.28,15.28,0,0,0-7.4,5.4,12.68,12.68,0,0,0-1.24,2.08C296.5,354.41,296.37,354.66,296.37,354.66Z",
    style: {
      fill: "#1990FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.46,382.27c.09.11-7.84,6.89-17.72,15.15s-18,14.85-18.06,14.74,7.84-6.89,17.72-15.14S323.37,382.16,323.46,382.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.19,411.27a9.22,9.22,0,0,1-1.33-.95l-3.52-2.74c-2.95-2.34-7-5.6-11.46-9.22s-8.47-6.92-11.36-9.33l-3.41-2.88a9.08,9.08,0,0,1-1.2-1.1,10,10,0,0,1,1.33.95l3.51,2.74c2.95,2.34,7,5.6,11.46,9.22s8.47,6.92,11.37,9.33l3.4,2.87A11.39,11.39,0,0,1,325.19,411.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.94,382.66c.08.11-7.5,5.92-16.95,13s-17.17,12.67-17.26,12.55,7.5-5.92,16.95-13S406.85,382.54,406.94,382.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.88,407.26c-.07.12-8.13-4.87-18-11.16s-17.78-11.47-17.71-11.6,8.13,4.88,18,11.16S410,407.14,409.88,407.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.76,455.83c-.11-.1,7.77-8.36,17.59-18.43s17.87-18.18,18-18.08-7.77,8.36-17.59,18.44S324.86,455.93,324.76,455.83Z",
    style: {
      fill: "#1990FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.07,455.82s-.13-.11-.33-.35l-.84-1c-.78-1-1.82-2.29-3.09-3.87-2.61-3.26-6.31-7.69-10.6-12.4s-8.36-8.8-11.36-11.7L328.29,423l-1-.94a2.19,2.19,0,0,1-.31-.35s.15.08.38.27l1,.87c.89.76,2.15,1.89,3.69,3.31,3.06,2.84,7.18,6.9,11.49,11.62s8,9.2,10.5,12.52c1.28,1.66,2.29,3,3,4l.77,1.1A2,2,0,0,1,358.07,455.82Z",
    style: {
      fill: "#1990FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.21,413.76s.32,24.57-5.88,39.28l-37.79-6.44s11.38-23.28,8.28-36.22Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.2,412.84S271.46,443,268.56,452L231,444.54s7.73-29.16,7.63-37.28Z",
    style: {
      fill: "#1990FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.44,420.78c0,.14,5.58,1.44,12.53,2.9s12.6,2.53,12.63,2.4-5.58-1.44-12.53-2.9S242.47,420.64,242.44,420.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.48,427.17c0,.14,5.58,1.43,12.53,2.9s12.6,2.53,12.63,2.4-5.58-1.44-12.53-2.9S241.51,427,241.48,427.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,434.4A8.82,8.82,0,0,0,249,435c1.29.31,3.08.72,5.05,1.14s3.78.76,5.09,1a8.65,8.65,0,0,0,2.14.26,9.65,9.65,0,0,0-2.07-.61c-1.28-.32-3.07-.73-5.05-1.14s-3.78-.77-5.08-1A8.69,8.69,0,0,0,247,434.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455,344.77s3.87,23.94-.05,39.21l-37.84-.81s7.74-24.38,2.83-36.57Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.83,343.87s-.25,30.11-1.78,39.3l-37.77-1.79s3.31-29.6,2-37.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.64,357.27c0,.14,5.68.26,12.69.27s12.7-.09,12.7-.23-5.68-.26-12.7-.27S422.64,357.13,422.64,357.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423,363.64c0,.14,5.68.26,12.69.27s12.7-.09,12.7-.23-5.68-.26-12.7-.27S423,363.5,423,363.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.77,369.51a8.75,8.75,0,0,0,2.12.19c1.31,0,3.12.07,5.12.08s3.8,0,5.11-.07a8.87,8.87,0,0,0,2.12-.17,8.5,8.5,0,0,0-2.12-.18c-1.31-.05-3.11-.08-5.11-.09s-3.81,0-5.12.07A8.87,8.87,0,0,0,429.77,369.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463,275.74c-7.06,0-14.17-4.43-17.91-11.4a34,34,0,0,1-3.19-22.6c2.07-10,8.69-18.2,16.87-20.82,6.95-2.23,19.37-1,25.23,8.81a29.59,29.59,0,0,1,4,15.83,3,3,0,1,1-6-.4,24.14,24.14,0,0,0-3.22-12.35c-4.52-7.55-14.43-7.4-18.25-6.18-7,2.24-11.48,9.81-12.83,16.32a27.9,27.9,0,0,0,2.61,18.56c2.95,5.5,8.92,8.92,14.21,8.11a3,3,0,0,1,.91,5.93A16.1,16.1,0,0,1,463,275.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.32,275.74c-7.07,0-14.17-4.43-17.91-11.4a34,34,0,0,1-3.2-22.6c1.75-8.44,7.67-18.16,17-20.84a22,22,0,0,1,13.62.69l-2.16,5.6a16.13,16.13,0,0,0-9.8-.53c-6.88,2-11.36,9.62-12.74,16.29a27.9,27.9,0,0,0,2.61,18.56c2.95,5.51,8.93,8.92,14.21,8.11l.91,5.93A16.19,16.19,0,0,1,269.32,275.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "460.53 245.71 457.77 260.82 498.38 260.82 501.99 245.86 460.53 245.71",
    style: {
      fill: "#1990FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.61,273.35a6.46,6.46,0,1,1-6.45-6.45A6.46,6.46,0,0,1,279.61,273.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.12,273.35a6.46,6.46,0,1,1-6.45-6.45A6.46,6.46,0,0,1,473.12,273.35Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-30"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "366.55 148.32 355.93 188.6 319.27 192.54 319.27 199.04 370.78 200.85 380.46 155.66 366.55 148.32",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382,201.92s-57.28-2.73-73.59,10S300,245.55,300,245.55l92.18-.24,8.14-46.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.75,232.75a4.28,4.28,0,0,1-.83-.06c-.54-.06-1.33-.14-2.35-.27-2-.25-5-.67-8.6-1.28a245.26,245.26,0,0,1-28-6.47c-5.38-1.59-10.47-3.19-15.17-4.36a66.44,66.44,0,0,0-12.67-2,38.06,38.06,0,0,0-8.63.5c-1,.12-1.77.38-2.31.47a7,7,0,0,1-.81.15,4.15,4.15,0,0,1,.79-.25,20.33,20.33,0,0,1,2.29-.57,35.68,35.68,0,0,1,8.68-.67A65.22,65.22,0,0,1,337,219.85c4.73,1.14,9.83,2.74,15.19,4.33A274.05,274.05,0,0,0,380,230.77c3.61.66,6.54,1.13,8.57,1.45l2.34.37A5.12,5.12,0,0,1,391.75,232.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.51,220a38,38,0,0,0-5.07-3.53,38.42,38.42,0,0,0-5.79-2.16,5,5,0,0,1,1.83.18,16.57,16.57,0,0,1,4.2,1.52,16.83,16.83,0,0,1,3.64,2.59A5,5,0,0,1,338.51,220Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.07,326.43l.77,24.07L384,369.72a2.46,2.46,0,0,0,2,3h0a2.46,2.46,0,0,0,2.16-.66c3.64-3.56,17-16.72,16.83-18.47-.18-2,.87-25.46.87-25.46Z",
    style: {
      fill: "#1990FF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.91,372.76l19-20.76v1a3.7,3.7,0,0,1-.86,2.42c-1.51,1.81-5.8,6.72-15.89,16.66a2.46,2.46,0,0,1-2.23.66Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399.87,344.27a1.5,1.5,0,0,0-.39,2,1.44,1.44,0,0,0,1.93.4,1.56,1.56,0,0,0,.4-2.07,1.48,1.48,0,0,0-2.05-.2",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M391.32,362.18c-.14.07-.7-1.18-2.13-1.85a7.24,7.24,0,0,0-2.78-.5c0-.06.28-.25.84-.34a3.91,3.91,0,0,1,3.8,1.83C391.33,361.81,391.37,362.16,391.32,362.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.63,365.43a18.92,18.92,0,0,0-2.14-1,21.1,21.1,0,0,0-2.36-.28,2.72,2.72,0,0,1,2.5-.23C389.05,364.3,389.75,365.36,389.63,365.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.47,358a25.16,25.16,0,0,0-3.2-1.79,23.88,23.88,0,0,0-3.58-.8,6.71,6.71,0,0,1,6.78,2.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.85,350.68c-.06.15-1.4-.4-3.13-.44s-3.1.38-3.16.23a6.15,6.15,0,0,1,6.29.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.8,343.61a12.07,12.07,0,0,0-3.25-.55,11.81,11.81,0,0,0-3.18.83c0-.05.22-.36.77-.68A5.36,5.36,0,0,1,394,343C394.55,343.27,394.84,343.55,394.8,343.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.58,341.71a2.24,2.24,0,0,1,0-.91,6.29,6.29,0,0,1,.71-2.39,2.75,2.75,0,0,1,1.19-1.35,1,1,0,0,1,1.12.21,1.62,1.62,0,0,1,.39,1.08,3.5,3.5,0,0,1-3,3.26,4.05,4.05,0,0,1-4-2.08,1.4,1.4,0,0,1-.08-1.17,1,1,0,0,1,1-.53,3.51,3.51,0,0,1,1.6.81,7.27,7.27,0,0,1,1.66,1.86,2.5,2.5,0,0,1,.38.83,11.28,11.28,0,0,0-2.27-2.39,3.25,3.25,0,0,0-1.4-.67.53.53,0,0,0-.56.28,1,1,0,0,0,.1.77,3.61,3.61,0,0,0,3.48,1.76,3,3,0,0,0,2.61-2.73,1.15,1.15,0,0,0-.24-.76.53.53,0,0,0-.62-.13,2.57,2.57,0,0,0-1,1.13A9.71,9.71,0,0,0,391.58,341.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.27,198.58s-24.77,46.83-25.11,55,0,83.48,0,83.48H413.5c1,0,6.75-33.93,5.58-41.74s-5.3-49.79-5.3-49.79h22.06s6.05-6.47,5.83-14.68c-.13-4.53-3.09-13.79-6-18.7-1.89-3.15-14-19.64-14-19.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.61,201.75a1.35,1.35,0,0,1-.11.27c-.09.2-.21.45-.36.76l-1.44,2.92c-.65,1.27-1.42,2.81-2.32,4.6l-1.44,2.87-1.51,3.27L384,232.53c-1.41,3-2.89,6.21-4.43,9.5l-2.33,5a27,27,0,0,0-1.7,5.38,29,29,0,0,0-.59,5.63c-.06,1.87-.1,3.72-.13,5.53,0,3.64-.07,7.14-.06,10.48,0,6.68.08,12.7.15,17.75s.13,9.1.18,12c0,1.38,0,2.47,0,3.25,0,.35,0,.63,0,.85s0,.29,0,.29a.85.85,0,0,1,0-.29c0-.22,0-.5,0-.84,0-.79-.08-1.87-.14-3.26-.1-2.82-.23-6.91-.34-12s-.23-11.06-.26-17.75c0-3.34,0-6.85,0-10.48,0-1.82.06-3.67.13-5.55a29.47,29.47,0,0,1,.59-5.72,27.55,27.55,0,0,1,1.74-5.48l2.34-5,4.46-9.48,7.58-16.05,1.54-3.26c.53-1,1-2,1.48-2.85l2.39-4.56c.65-1.23,1.17-2.19,1.53-2.88.17-.3.31-.54.41-.74S398.6,201.74,398.61,201.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.59,217.7a46.71,46.71,0,0,1-2-5.85,46.14,46.14,0,0,1-1.71-5.94,29.82,29.82,0,0,1,2.2,5.79A30.12,30.12,0,0,1,390.59,217.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.16,293.85a2,2,0,0,1-.12-.53q-.07-.61-.21-1.53c-.18-1.41-.41-3.33-.7-5.66-.55-4.84-1.29-11.41-2.11-18.67s-1.49-13.91-1.9-18.7c-.19-2.34-.35-4.26-.47-5.67,0-.63-.08-1.14-.11-1.55a3.72,3.72,0,0,1,0-.54,1.81,1.81,0,0,1,.11.53c.05.41.12.92.2,1.54.16,1.41.38,3.32.64,5.66.53,4.84,1.25,11.42,2,18.68s1.46,13.83,2,18.68c.22,2.34.41,4.26.54,5.67.05.62.09,1.14.12,1.55A3.16,3.16,0,0,1,419.16,293.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.42,73.16c-.59-4,2.84-7.85,6.8-8.32s7.95,2,9.77,5.61a14.58,14.58,0,0,1,.3,11.64c-1,2.53-2.85,5.09-5.54,5.29s-4.75-1.85-6.53-3.74",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.27,93c-8-17.53,11-26.34,21.33-23.42,9.72,2.75,13.87,7.59,15.47,14.09a32.08,32.08,0,0,1-1,19.74c-1.26,3.06-3.52,6.16-6.8,6.54",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.8,79.31a3.29,3.29,0,0,1,2.95,3.35h0l-1.87,44.62c-.07,5.27-7.76,8.25-13.41,8.13h0c-5.69-.12-5.88-2.92-6-7.93-.13-8.37-.13-11.52-.13-11.47s-7.2-1.2-8.69-10.59c-.75-4.67-.51-12.33-.12-18.59.36-5.63,4.09-12.55,9.71-12Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.21,92.17a1.2,1.2,0,0,0,1.16,1.22,1.15,1.15,0,0,0,1.24-1.09,1.21,1.21,0,0,0-1.16-1.22A1.15,1.15,0,0,0,385.21,92.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.22,90.82c.15.15,1.07-.52,2.36-.52s2.25.65,2.39.49-.08-.35-.5-.65a3.33,3.33,0,0,0-1.91-.59,3.08,3.08,0,0,0-1.87.61C383.29,90.46,383.15,90.75,383.22,90.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.88,92.17A1.21,1.21,0,0,0,399,93.39a1.15,1.15,0,0,0,1.24-1.09,1.21,1.21,0,0,0-1.16-1.22A1.15,1.15,0,0,0,397.88,92.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396,91.06c.15.15,1.06-.52,2.35-.52s2.25.65,2.39.5-.08-.36-.5-.66a3.3,3.3,0,0,0-1.91-.59,3.17,3.17,0,0,0-1.87.61C396,90.7,395.89,91,396,91.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.26,100.67a8.92,8.92,0,0,0-2.1-.38c-.33,0-.65-.1-.7-.32a1.7,1.7,0,0,1,.22-1c.31-.8.63-1.64,1-2.52a43.85,43.85,0,0,0,2.2-6.59,42.59,42.59,0,0,0-2.73,6.4l-.94,2.54a1.93,1.93,0,0,0-.17,1.3.84.84,0,0,0,.55.48,2.43,2.43,0,0,0,.56.08A8.54,8.54,0,0,0,391.26,100.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.37,116A23.85,23.85,0,0,0,403,112.65s-3.06,6.46-12.46,5.58Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.81,103.79a2.34,2.34,0,0,1,2.09-.86,2.12,2.12,0,0,1,1.48.79,1.35,1.35,0,0,1,.1,1.54,1.56,1.56,0,0,1-1.7.43,4.79,4.79,0,0,1-1.66-1,1.48,1.48,0,0,1-.37-.38.44.44,0,0,1,0-.48",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.08,101.57c-.21,0-.22,1.39-1.42,2.39s-2.7.84-2.71,1,.33.27,1,.29a3.54,3.54,0,0,0,2.27-.79,3.08,3.08,0,0,0,1.1-2C395.33,101.91,395.17,101.56,395.08,101.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.38,88.79c.13.35,1.43.18,2.95.37s2.75.59,2.95.28c.09-.15-.13-.48-.62-.83a4.93,4.93,0,0,0-2.19-.76,4.85,4.85,0,0,0-2.3.27C395.61,88.34,395.33,88.62,395.38,88.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.7,87.06c.23.3,1.12,0,2.2,0s2,.2,2.19-.11c.09-.15,0-.45-.45-.72a3,3,0,0,0-1.78-.49,3.08,3.08,0,0,0-1.75.59C383.73,86.62,383.6,86.92,383.7,87.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.93,71.75a19,19,0,0,0-9,2.8,13.06,13.06,0,0,0-6.44,7.65,2.68,2.68,0,0,0,.08,2.12,2.06,2.06,0,0,0,2.57.55,5.87,5.87,0,0,0,2.1-1.93,4,4,0,0,0,7.8-.09,3.51,3.51,0,0,0,3.62,3.23,4.64,4.64,0,0,0,4-3.15,11.62,11.62,0,0,0,1.65,4.58,4,4,0,0,0,4.25,1.74,8.4,8.4,0,0,0,.06,4.2c.5,1.32,2.49,23.91,3.83,23.45s1.29-23.5,1.59-24.84a31.35,31.35,0,0,0,1-7.87,11.53,11.53,0,0,0-9.3-11.69,30.73,30.73,0,0,0-8.18-.75",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.75,112.89s-.09.06-.29.13a3.93,3.93,0,0,1-.87.21,7.4,7.4,0,0,1-7.17-3.36,9.69,9.69,0,0,1-1.23-5.88c.15-2.15.65-4.11.88-5.91a45,45,0,0,0,.42-4.82c0-1.38,0-2.49,0-3.27a5.58,5.58,0,0,1,0-1.2A5.06,5.06,0,0,1,406.7,90a32.25,32.25,0,0,1,.16,3.29,39.11,39.11,0,0,1-.31,4.87c-.22,1.84-.69,3.81-.84,5.88a9.44,9.44,0,0,0,1.12,5.6,6.92,6.92,0,0,0,3.58,2.93,7.53,7.53,0,0,0,3.15.48C414.33,113,414.74,112.84,414.75,112.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.62,70.54a4.25,4.25,0,0,1,.49,2.23,7.17,7.17,0,0,1-7,7.3,4.23,4.23,0,0,1-2.24-.4c0-.09.86.15,2.22,0a7.18,7.18,0,0,0,6.69-6.94C392.81,71.4,392.53,70.56,392.62,70.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,81.6c.05,0-.07.64-.79,1.34a4.77,4.77,0,0,1-3.54,1.21,7.81,7.81,0,0,1-3.53-1.21c-.81-.51-1.25-.9-1.21-1a6.17,6.17,0,0,1,1.38.63,9.24,9.24,0,0,0,3.39,1,4.91,4.91,0,0,0,3.27-1C393.7,82.11,393.94,81.56,394,81.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.65,78.73a8.78,8.78,0,0,1-.18,2.57,12.92,12.92,0,0,1-2.3,5.79,7.81,7.81,0,0,1-5.38,3.06,5.11,5.11,0,0,1-1.91-.19c-.43-.13-.64-.26-.63-.29a9.43,9.43,0,0,0,2.5.11,7.87,7.87,0,0,0,5-3,14.15,14.15,0,0,0,2.35-5.54A20.77,20.77,0,0,1,416.65,78.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.37,83.28a2.59,2.59,0,0,1,.15.8,15.76,15.76,0,0,1,.05,2.19,10.94,10.94,0,0,1-2.5,6.73,7.57,7.57,0,0,1-3.33,2.27,6.52,6.52,0,0,1-3.29.2,5.37,5.37,0,0,1-2.05-.86c-.42-.31-.6-.54-.58-.56a7.61,7.61,0,0,0,2.69,1.06,6.57,6.57,0,0,0,3.07-.29,7.49,7.49,0,0,0,3.1-2.16,11.42,11.42,0,0,0,2.53-6.42C418.37,84.43,418.28,83.29,418.37,83.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.56 204.15 268.41 245.66 293.4 245.66 311.2 203.82 286.56 204.15",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.36,160l20.47,40.26h64.56L355.78,195l-18.7-.56-15.25-33.94a5.87,5.87,0,0,0-5.36-3.47H275.18A2,2,0,0,0,273.36,160Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.69,178.05a2.47,2.47,0,1,1-2.47-2.47A2.48,2.48,0,0,1,305.69,178.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.35,
    y: 200.34,
    width: 78.92,
    height: 3.85,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.96 202.27 364.97 245.7 376.45 245.7 378.95 240.73 381.25 235.5 365.27 204.19 340.96 202.27",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.68,127.81s-13.94,4.91-16.94,20.51l14.72,7.34Z",
    style: {
      fill: "#1990FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.68,127.81s-9.75,21.86-9.38,33.8c.13,4.15,2.85,15,2.85,15l5.07,26.86s38.81-5.25,39.67-5.25-1.3-22.05-1.3-22.05l6.33-42.37s-2.9-5.77-16-7.77C402.07,124.8,382.68,127.81,382.68,127.81Z",
    style: {
      fill: "#1990FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379,140.5c.09.05-.93,1.68-2.16,4.5a40.15,40.15,0,0,0-1.8,5.08,44.14,44.14,0,0,0-1.27,6.47,45.25,45.25,0,0,0-.21,6.59,40.43,40.43,0,0,0,.63,5.35c.56,3,1.2,4.84,1.1,4.87a6.47,6.47,0,0,1-.5-1.25,15.74,15.74,0,0,1-.46-1.51c-.16-.6-.37-1.27-.51-2a38.13,38.13,0,0,1-.74-5.4,42.27,42.27,0,0,1,.17-6.68,41.4,41.4,0,0,1,1.33-6.55,36,36,0,0,1,1.93-5.09,20.25,20.25,0,0,1,.94-1.87,15,15,0,0,1,.79-1.37A6.75,6.75,0,0,1,379,140.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.4,127.61l.56-6a2.55,2.55,0,0,1,2.5-2.3l19.15-.29a2.29,2.29,0,0,1,2.31,2.11l.49,6.47a16.54,16.54,0,0,1-7.69,7.8c-5.63,2.73-14.38,2.82-14.38,2.82Z",
    style: {
      fill: "#1990FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.41,119.36c.06,0-.22.39-.34,1a10.93,10.93,0,0,0,0,2.66,15,15,0,0,1,0,3.88,14.6,14.6,0,0,1-.52-3.85,7.5,7.5,0,0,1,.12-2.78C392,119.58,392.38,119.31,392.41,119.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397,126.78a13.62,13.62,0,0,1-.48-3.76,16.36,16.36,0,0,1,0-2.7c.1-.72.39-1.09.45-1s-.09.42-.08,1.08S397,122,397,123A14.22,14.22,0,0,1,397,126.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.75,126.62A13.6,13.6,0,0,1,402,123a13.6,13.6,0,0,1-.23-3.72,13.46,13.46,0,0,1,.75,3.65A13.67,13.67,0,0,1,402.75,126.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.71,127a12.5,12.5,0,0,1-.72-4,12.47,12.47,0,0,1,.1-4.09,22,22,0,0,1,.42,4A21.89,21.89,0,0,1,407.71,127Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M411.51,149.91c-.77,6.73-.26,18.33,2.12,24.68l11.18-18.47Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M424.88,132.41l.06.06a28.52,28.52,0,0,1,6.76,11.79l2.06,9.39-22,3.4a27.39,27.39,0,0,1-.84-12.3C412,137.67,424.88,132.41,424.88,132.41Z",
    style: {
      fill: "#1990FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.76,153.65a2.41,2.41,0,0,1-.44.11l-1.26.23-4.71.77-15.94,2.42-.28,0v-.29c-.05-1.33-.09-2.71-.12-4.13-.05-3.69,0-7.22.22-10.43a17,17,0,0,1,2.56-8.11,12.07,12.07,0,0,1,4.1-4,7.75,7.75,0,0,1,1.42-.66,1.81,1.81,0,0,1,.52-.15s-.7.27-1.84,1a12.26,12.26,0,0,0-3.89,4,17.11,17.11,0,0,0-2.4,8c-.23,3.18-.22,6.7-.16,10.39,0,1.4.07,2.79.1,4.11l-.29-.25,16-2.25,4.73-.61,1.28-.15A1.55,1.55,0,0,1,433.76,153.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.29,139.86a14.74,14.74,0,0,1-3.06-2.37,14.35,14.35,0,0,1-2.72-2.76,29,29,0,0,1,5.78,5.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.32,151.43a10.56,10.56,0,0,1-2.69,2,11.07,11.07,0,0,1-3,1.54,21.7,21.7,0,0,1,5.67-3.52Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.59,154.28a17.24,17.24,0,0,1,0-4.28,18.29,18.29,0,0,1,.52-4.24,17.46,17.46,0,0,1,0,4.27A18,18,0,0,1,396.59,154.28Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.52,165.85a29.37,29.37,0,0,1-2.78-3,30.12,30.12,0,0,1-2.75-3,11.27,11.27,0,0,1,3.13,2.69A11.61,11.61,0,0,1,408.52,165.85Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.2,141.66a13.2,13.2,0,0,1-2.91,2.28,13.68,13.68,0,0,1-3.21,1.84A13.12,13.12,0,0,1,407,143.5,14,14,0,0,1,410.2,141.66Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.42,132.91a14.68,14.68,0,0,1-3.18,2.35,15.18,15.18,0,0,1-3.46,1.92,14.89,14.89,0,0,1,3.18-2.36A15.85,15.85,0,0,1,399.42,132.91Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.14,136.39a12.14,12.14,0,0,1-1.52-3.14,12.16,12.16,0,0,1-1-3.34,11.59,11.59,0,0,1,1.52,3.15A11.65,11.65,0,0,1,409.14,136.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.51,140.78a16.37,16.37,0,0,1-4.1-4.09,8.3,8.3,0,0,1,2.23,1.86A8.07,8.07,0,0,1,422.51,140.78Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417,150.53a9.05,9.05,0,0,1-.43-3.06,8.91,8.91,0,0,1,.09-3.08,18.26,18.26,0,0,1,.34,6.14Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.11,148.51a9.16,9.16,0,0,1-3.5-.12,9.37,9.37,0,0,1-3.37-.93,15.74,15.74,0,0,1,3.45.42A16.32,16.32,0,0,1,428.11,148.51Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.31,168.66a16.79,16.79,0,0,1-2-3.65,17,17,0,0,1-1.54-3.87,16.79,16.79,0,0,1,2,3.65A16.77,16.77,0,0,1,383.31,168.66Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,184.44a13.84,13.84,0,0,1-2.43-2.91,14.66,14.66,0,0,1-2-3.22,14,14,0,0,1,2.44,2.91A13.9,13.9,0,0,1,398,184.44Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.14,177.82a13.29,13.29,0,0,1-3.32,1.56,12.69,12.69,0,0,1-3.51,1.07,25.61,25.61,0,0,1,6.83-2.63Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.23,190.6a16.57,16.57,0,0,1,2.39-5.28,8.37,8.37,0,0,1-1,2.75A8.26,8.26,0,0,1,380.23,190.6Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.82,145.41a4.72,4.72,0,0,1-1-2.55,4.63,4.63,0,0,1,.12-2.73,16.19,16.19,0,0,1,.4,2.64A16.57,16.57,0,0,1,370.82,145.41Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.53,180.48a10,10,0,0,1-3-1.35,10.34,10.34,0,0,1-2.72-1.8,10.27,10.27,0,0,1,3,1.35A10.86,10.86,0,0,1,387.53,180.48Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.18,163.82a27.62,27.62,0,0,1-5.66,5.13,14.31,14.31,0,0,1,2.66-2.76A14.05,14.05,0,0,1,397.18,163.82Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M391.27,163.51a17,17,0,0,0,4.45,9.3c2.5,2.44,6.37,3.67,9.62,2.4a2.29,2.29,0,0,0,1.55-1.44,1.86,1.86,0,0,0-1.25-2,7.56,7.56,0,0,0-2.51-.36,14.26,14.26,0,0,1-11.66-7.54"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M404.27,171.57s-.23.08-.67.12a9.25,9.25,0,0,1-1.86,0,11.88,11.88,0,0,1-2.69-.64,13,13,0,0,1-5.52-3.83,11.87,11.87,0,0,1-1.53-2.3,8.25,8.25,0,0,1-.69-1.73,2.05,2.05,0,0,1-.13-.67c.1,0,.37.9,1.14,2.22a13.49,13.49,0,0,0,1.57,2.16,15,15,0,0,0,2.45,2.17,15.23,15.23,0,0,0,2.88,1.53,13.17,13.17,0,0,0,2.57.72C403.3,171.54,404.27,171.47,404.27,171.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.22,187.69,363.7,186l10.21,6.69,39-9.36.92-26.72,17.33-2.28v32.35A14.84,14.84,0,0,1,416,201.15l-57.16-1.59-2.43-4.86-12.27-.37Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.45,183.28a5,5,0,0,1-.74.23l-2.12.55L401.76,186l-25.88,6.27-2.41.58-.1,0-.08,0-10.2-6.71.14,0-14.49,1.68.1-.06L345,192.63l-1,1.28a2.62,2.62,0,0,1-.38.42,4.32,4.32,0,0,1,.31-.47l1-1.32,3.72-4.94,0,0h.06l14.47-1.81h.08l.06,0,10.22,6.68-.18,0,2.41-.58,25.91-6.14,7.87-1.81,2.14-.47A5,5,0,0,1,412.45,183.28Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.13,191.84a36.43,36.43,0,0,1-5.63.22h-1l.14-.05a25.87,25.87,0,0,1-3.65,2.8,27.7,27.7,0,0,1,3.36-3.14l.06-.06h1.11A34.25,34.25,0,0,1,357.13,191.84Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.64,187.65a10.68,10.68,0,0,0-2.85-3,10.46,10.46,0,0,0-3.91-1.28,2.51,2.51,0,0,1,1.26-.1,6.67,6.67,0,0,1,5,3.17A2.53,2.53,0,0,1,419.64,187.65Z",
    style: {
      fill: "#eb996e"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeManagement);
export default __webpack_public_path__ + "static/media/time-management.71afbd5749cd557dc1048bf5a9196e23.svg";
export { ForwardRef as ReactComponent };